import { useGetOfficesQuery } from '../services/offices.service';

interface UseOfficeProps {
  officeId: string;
}

const useOffice = ({ officeId }: UseOfficeProps) => {
  const { data: offices, isLoading } = useGetOfficesQuery({
    filters: undefined,
    paginated: { page: 1, pageSize: 1000 },
  });

  const office = offices?.items?.find((office) => office.id === officeId);

  return {
    office,
    isLoading,
  };
};

export default useOffice; 